const form = $('#form');
var regex = /^[_a-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})$/g;
$('#lalert').css('display','');
$('#alert').css('display','');

var error = {
	isEmpty:{

		email:"Entre com um email válido",

		senha:"A senha não pode estar vazia"
	}
};

/**
 * Description
 *
 * @param {Object} event
 *
 * @return {number} boolean
 */
$('#Sign-in').on('click', function(event) {
	var isValid = true;
	var email    = $('#email')
	var password = $('#senha')
	$('#alert').attr('class', '');
	$('#lalert').attr('display','');
	
	// console.log(error.isEmpty.email);return false;
	if (!regex.test(email.val())) {
		removeAlert(5000);
		$('#alert').attr('class', 'alerrt alert-danger text-bg-danger').text(error.isEmpty.email);
		isValid = false;
	}else
	if (password.val().lenght <= 0 || password.val() == '') {
		removeAlert(5000);
		$('#alert').attr('class', 'alerrt alert-danger text-bg-danger').text(error.isEmpty.senha);
		isValid = false;
	}

	if (!isValid) {
	    event.preventDefault();
	    $('#alert').css('display','');
	    return;
	}
});


var alertElement = document.getElementById('alert');

function removeAlert(timer) {
  if (alertElement) {
    setTimeout(function() {
      if (alertElement.innerHTML.length > 0) {
        alertElement.innerHTML = null; // Remove o conteúdo do elemento, incluindo texto e tags HTML
      }
      alertElement.style.display = 'none'; // Oculta o elemento
    }, timer);
  }
}